export enum ExportTypeEnum {
  UNKNOWN = "unknown",
  OFFER = "offer",
}
